document.addEventListener('DOMContentLoaded', function() {
  const truncateElements = document.querySelectorAll('[data-truncate="true"]');

  truncateElements.forEach(function(element) {
    // Guard: skip if already initialized
    if (element.classList.contains('truncate--initialized')) {
      return;
    }
    element.classList.add('truncate--initialized');

    const charLimit = parseInt(element.dataset.charLimit, 10) || 500;
    const showMoreText = element.dataset.showMore || 'Show more';
    const showLessText = element.dataset.showLess || 'Show less';

    // Target the wrapper element directly (server-side already rendered truncated content here)
    const targetElement = element;
    
    // Get full content from data attribute (server-rendered full HTML)
    const fullContent = element.dataset.fullContent;
    
    // Get currently rendered (truncated) content from DOM
    const truncatedContent = targetElement.innerHTML;

    if (!fullContent || fullContent.length <= charLimit) {
      return;
    }

    const showMoreLink = document.createElement('a');
    showMoreLink.href = '#';
    showMoreLink.textContent = showMoreText;
    showMoreLink.classList.add('truncate__show-more');
    showMoreLink.style.marginLeft = '8px';
    showMoreLink.style.cursor = 'pointer';

    showMoreLink.addEventListener('click', function(event) {
      event.preventDefault();
      showMoreLink.remove();
      targetElement.innerHTML = fullContent;

      const showLessLink = document.createElement('a');
      showLessLink.href = '#';
      showLessLink.textContent = showLessText;
      showLessLink.classList.add('truncate__show-less');
      showLessLink.style.marginLeft = '8px';
      showLessLink.style.cursor = 'pointer';

      showLessLink.addEventListener('click', function(event) {
        event.preventDefault();
        targetElement.innerHTML = truncatedContent;
        element.appendChild(showMoreLink);
        showLessLink.remove();
      });

      element.appendChild(showLessLink);
    });

    // Server-side already truncated, just add the show more link
    element.appendChild(showMoreLink);
  });
});